export interface Constraint {
  id: string;
  name: string;

  versionId: number;
  armyId: number | null;
  armyOrganisationId: number | null;

  includeChildSelections: boolean;
  scope: ConstraintScope;
  shared: boolean;
  type: ConstraintType;
  field: ConstraintField;
  percentValue: boolean;
  value: number;
}

export enum ConstraintItemType {
  Roster = 'Roster',
  Army = 'NinthAge::Army',
  Unit = 'NinthAge::Unit',
  UnitOption = 'NinthAge::UnitOption',
  UnitOptionGroup = 'NinthAge::UnitOptionGroup',
  Troop = 'NinthAge::Troop',
  ArmyOrganisation = 'NinthAge::ArmyOrganisation',
  Constraint = 'NinthAge::Constraint',
  Organisation = 'NinthAge::Organisation',
}

export enum ConstraintScope {
  Roster = 'Roster',
  Parent = 'Parent',
  Force = 'Force',
}

export enum ConstraintType {
  Max = 'Max',
  Min = 'Min',
}

export enum ConstraintField {
  Selections = 'Selections',
  Points = 'Points',
  Models = 'Models',
}
